import React, { useCallback, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "./index.css"
import _ from "../../_"
import Spinner from "../../components/info/spinner"
import { useGlobal } from '../../context/global'
import DP from '../../components/custom/dp'

const ResetPass = () => {

  const { api } = useGlobal()

  const InitState = 0
  const UserVerificationPending = 1
  const OTPSendingPending = 2
  const OTPSendingSuccessful = 3
  const OTPVerificationPending = 4
  const PasswordUpdatePending = 5

  const initUserPrompt = "Password must be atleast 4 charaters long"
  const expirySeconds = 300
  const resendWaitSeconds = 100

  var [loginState, setLoginState] = useState(InitState)
  var [statusText, setStatusText] = useState("")
  var [resendOTP, setResendOTP] = useState("")
  var [showResendOTP, setShowResendOTP] = useState(false)
  var [buttonText, setButtonText] = useState("Send OTP")
  var [promptText, setPromptText] = useState(initUserPrompt)
  var [inputType, setInputType] = useState("text")
  var [inputMaxLen, setInputMaxLen] = useState(-1)
  var [timerOn, setTimerOn] = useState(false)

  var id = useRef()
  var pass1 = useRef()
  var pass2 = useRef()
  var save = useRef()
  var target = useRef()
  var timerID = useRef()
  var expiry = useRef()
  var users = useRef()

  const handleSendOTP = () => {

    if (pass1.current.value != pass2.current.value) {
      toast.error("Passwords do not match. Please try again.")
      return
    }

    if (!pass1.current.value.trim()) {
      toast.error("Empty password is not allowed!")
      return
    }

    if (pass1.current.value.length < 4) {
      toast.error("Password must contain atleast 4 characters!")
      return
    }

    if (!id.current.value.trim()) {
      toast.error("Empty phone number!")
      return
    }

    if (loginState == OTPSendingPending) {
      return
    }
    setLoginState(UserVerificationPending)
    api.call("/verify-user", { id: id.current.value.trim().toPhoneCase() })
      .then(res => {
        users.current = res.data
        save.current = pass1.current.value
        setLoginState(OTPSendingPending)
      }).catch(err => {
        setLoginState(InitState)
        if (err && err.response && err.response.status == 404) {
          toast.error("This user is not found in our records!")
        } else {
          console.log(err)
          toast.error(`User could not be verified!`)
        }
      })
  }

  const handleVerifyOTP = () => {

    if (loginState == UserVerificationPending) {
      return
    }
    setLoginState(OTPVerificationPending)
    api.call("/verify-otp", {
      id: `sevabase-resetpass-${target.current}`,
      otp: id.current.value.trim()
    }).then(() => {
      setLoginState(PasswordUpdatePending)

      api.call("/update-pass", {
        phone: target.current,
        pass: save.current.hash()
      }).then(() => {
        window.location = "/"
      }).catch(err => {
        alert(`Error: ${err}\nCould not update password. Please try again!`)
        window.location = window.location
      })

    }).catch(err => {
      setLoginState(OTPSendingSuccessful)
      if (err.response.status == 403) {
        id.current.value = ""
        toast.error(`Incorrect OTP. Please enter again.`)
      } else if (err.response.status == 408) {
        id.current.value = ""
        toast.error(`Request timed-out. Please try again`)
      } else {
        toast.error(`Could not verify OTP: ${err.response.data}. Please try again!`)
      }
    })
  }

  useEffect(() => {
    if (loginState == InitState) {
      setStatusText("")
      setButtonText("Send OTP")
      setPromptText(initUserPrompt)
      setInputType("text")
      setInputMaxLen(-1)
    } else if (loginState == UserVerificationPending) {
      setStatusText("Verifying user..")
      setButtonText("Verifying user..")
      setPromptText("Verifying user..")
    } else if (loginState == OTPSendingPending) {
      setStatusText("Sending OTP. This may take a couple of minutes...")
      setButtonText("Sending OTP...")
      setPromptText("OTP will be sent in WhatsApp!")
    } else if (loginState == OTPSendingSuccessful) {
      setButtonText("Verify OTP")
      setPromptText(`Enter the 6-digit OTP sent over ${_.phoneRegex.test(target.current) ? "WhatsApp" : "e-mail"} to ${target.current}`)
      setTimerOn(true)
      setInputType("number")
      setInputMaxLen(6)
      id.current.focus()
      if (!expiry.current) {
        expiry.current = moment().add(expirySeconds, 'seconds')
      }
    } else if (loginState == OTPVerificationPending) {
      setButtonText("Verifying OTP...")
    } else if (loginState == PasswordUpdatePending) {
      setStatusText("Updating Password..")
      setTimerOn(false)
    } else {
      setStatusText("")
    }
  }, [loginState])

  useEffect(() => {
    if (loginState == OTPSendingPending) {
      clearInterval(timerID.current)
      const value = (id.current.value || target.current).trim().toPhoneCase()
      api.call("/send-otp", {
        id: `sevabase-resetpass-${value}`,
        target: value
      }).then(() => {
        if (!target.current) {
          target.current = id.current.value.trim().toPhoneCase()
        }
        setLoginState(OTPSendingSuccessful)
        setShowResendOTP(false)
        id.current.value = ""
      }).catch(err => {
        console.log(err)
        setLoginState(InitState)
        toast.error(`Could not send OTP: ${err.response.data}. Please try again!`)
      })
    }
  }, [loginState])

  useEffect(() => {
    if (timerOn) {
      setStatusText(`OTP will expire in 05:00`)
      timerID.current = setInterval(() => {
        const secondsRemaining = moment.utc(expiry.current.diff(moment())) / 1000
        if (secondsRemaining <= 1) {
          setTimerOn(false)
          setLoginState(InitState)
          toast.error("OTP expired! Please try again.")
          return
        }
        if (Math.floor(secondsRemaining) == expirySeconds - resendWaitSeconds) {
          setShowResendOTP(true)
        }
        setStatusText(`OTP will expire in ${moment.utc(expiry.current.diff(moment())).format('mm:ss')}`)
        if (!showResendOTP) {
          setResendOTP(`You can request to resend OTP after ${moment.utc(moment(expiry.current).subtract(expirySeconds - resendWaitSeconds, 'seconds').diff(moment())).format('mm:ss')}`)
        }
      }, 1000)
    } else {
      clearInterval(timerID.current)
    }
  }, [timerOn, showResendOTP])

  const handleSubmit = (e) => {
    if (e.code == "Enter") {
      if (loginState == OTPSendingSuccessful) {
        handleVerifyOTP()
      } else {
        handleSendOTP()
      }
    }
  }

  const handleResendOTP = () => {
    expiry.current = moment().add(expirySeconds, 'seconds')
    setLoginState(OTPSendingPending)
  }

  return (
    <div className="resetpass-container">

      <div className='resetpass-logo-cont'>
        <DP url="/favicon.png" size={[50, 15]} />
      </div>

      <div className='resetpass-status-cont'>
        <div className='resetpass-status'>{statusText}</div>
        {loginState == PasswordUpdatePending ? <Spinner className={"resetpass-spinner"} size={5} /> : null}
      </div>

      {loginState < PasswordUpdatePending ?
        <div className='resetpass-form'>
          <label className='resetpass-label'>{promptText}</label>


          {loginState <= UserVerificationPending ? <>
            <input
              className="resetpass-input"
              ref={pass1}
              type={"password"}
              placeholder='Enter new password'
            />

            <input
              className="resetpass-input"
              ref={pass2}
              type={"password"}
              placeholder='Re-enter new password'
            />
          </> : null}


          <input
            className="resetpass-input"
            ref={id}
            type={inputType}
            maxLength={inputMaxLen}
            onKeyDown={handleSubmit}
            placeholder='Enter reg. WhatsApp num'
          />

          <button
            className="resetpass-send-button"
            onClick={loginState == OTPSendingSuccessful ? handleVerifyOTP : handleSendOTP}
            disabled={loginState == OTPSendingPending || loginState == OTPVerificationPending}
          >
            {buttonText}
          </button>

          {loginState == OTPSendingSuccessful &&
            <div className='resetpass-buttons'>
              {!showResendOTP && <div className='resetpass-resend-info'>{resendOTP}</div>}
              {showResendOTP && <button className='resetpass-send-button resetpass-resend-button' onClick={handleResendOTP}>Resend OTP</button>}
            </div>
          }
        </div> : null
      }

      <div className='resetpass-login' onClick={() => {
        window.location = "/"
      }}>Back to login</div>

    </div>
  )
}

export default ResetPass